import React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import FormattedNumber from '/component/base/FormattedNumber';
import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';

import {styles} from './FcvCount.style';
interface FcvCountProps {
  tt: (key: string, fallback: string) => string;
  item: {
    fcv?: string | number;
  } | null;
}

export const FcvCount: React.FC<FcvCountProps> = ({tt, item}) => {
  const fcv = get(item, 'fcv', '');
  return (
    <View style={styles.attributes} testID={Reports.reportFCV}>
      <FormattedNumber
        value={fcv}
        boldText={false}
        truncate
        testID={Reports.reportFCVValue}
      />
      <Text testID={Reports.reportFCVLabel}> {tt('fcv', 'FCV')}</Text>
    </View>
  );
};

export default withTranslation('report.record.FcvCount')(FcvCount);
